import DOMPurify from "dompurify";

const HtmlContent = ({ content }) => {
  const sanitizedContent = DOMPurify.sanitize(content); // پاک‌سازی HTML
  return <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />;
};
export default HtmlContent;